(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-promo-band"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.accio-promo');
  if (!section) return;
  var reveals = Array.from(section.querySelectorAll('[data-reveal]'));
  var magneticBtns = Array.from(section.querySelectorAll('[data-magnetic]'));
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) {
    reveals.forEach(function(el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.revealDelay, 10) || 0;
        setTimeout(function() { el.classList.add('is-visible'); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.15 });
    reveals.forEach(function(el) { io.observe(el); });

    magneticBtns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.28) + 'px,' + (y * 0.28) + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = '';
        btn.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1), background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease';
        setTimeout(function() { btn.style.transition = ''; }, 500);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-usp-strip"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.accio-usp');
  if (!section) return;
  var reveals = Array.from(section.querySelectorAll('[data-reveal]'));
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    reveals.forEach(function(el) { el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.dataset.revealDelay, 10) || 0;
      setTimeout(function() { el.classList.add('is-visible'); }, delay);
      io.unobserve(el);
    });
  }, { threshold: 0.12 });
  reveals.forEach(function(el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halyvira-product-edit"] && !Shopify.designMode) return;
  try {
    (function(){function initTabs(scope){scope.querySelectorAll('[data-hv-tabs]').forEach(function(root){if(root.dataset.tabsReady)return;root.dataset.tabsReady='true';var buttons=Array.from(root.querySelectorAll('[data-tab]'));var panels=root.querySelectorAll('[data-panel]');function activate(btn,moveFocus){buttons.forEach(function(b){var active=b===btn;b.classList.toggle('is-active',active);b.setAttribute('aria-selected',String(active));b.tabIndex=active?0:-1});panels.forEach(function(p){var active=p.dataset.panel===btn.dataset.tab;p.classList.toggle('is-hidden',!active);p.hidden=!active});if(moveFocus)btn.focus();}buttons.forEach(function(btn,index){btn.addEventListener('click',function(){activate(btn,false)});btn.addEventListener('keydown',function(event){var next;if(event.key==='ArrowRight')next=(index+1)%buttons.length;else if(event.key==='ArrowLeft')next=(index-1+buttons.length)%buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=buttons.length-1;else return;event.preventDefault();activate(buttons[next],true);});});if(buttons.length)activate(buttons[0],false);});}initTabs(document);document.addEventListener('shopify:section:load',function(event){initTabs(event.target)});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
